module.exports = __webpack_public_path__ + "static/media/logoWhite.070120ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SkycoinLanding/components/Logo/logoWhite.svg
// module id = 1194
// module chunks = 0